// Translates to the magic strings used by signalr to determine what function to call

const WSMessageEnum = {
  UPDATE_CHAT_ROOM_FOR_CLIENT: 'UpdateChatRoomForClient',
  SHOW_TRAINER_TOAST: 'ShowToast',
};

export default WSMessageEnum;
